import axios from "axios";
import { API_BASE_URL } from "../config/config";

// const currentDomain = window.location.hostname; // Örn: "localhost" veya "www.example.com"

// const API_BASE_URL =
//   currentDomain === "localhost" ||
//   currentDomain === "127.0.0.1" ||
//   currentDomain === "aiconnect.com.tr" ||
//   currentDomain === "demo.aiconnect.com.tr"
//     ? "https://apis.aiconnect.com.tr/reportdid"
//     : `https://apis.${currentDomain}/reportdid`;

const ReportDidServices = {
  list: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      startEndDate: data.startEndDate,
      userID: data.userID,
    });
    return axios.get(`${API_BASE_URL}/reportdid/list?${params.toString()}`);
  },
  details: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      startEndDate: data.startEndDate,
      userID: data.userID,
      dest: data.dest,
      did: data.did,
    });
    return axios.get(`${API_BASE_URL}/reportdid/reportDetails?${params.toString()}`);
  },
  downloadAll: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      startEndDate: data.startEndDate,
      userID: data.userID,
      // dest: data.dest,
      // did: data.did,
    });
    return axios.get(`${API_BASE_URL}/reportdid/reportDownloadAll?${params.toString()}`);
  },
};

export default ReportDidServices;
